import { usePeopleManagementApi } from 'infrastructure/api';
import skillBasedQueueValidation from 'domain/gpo/skillBasedQueue/createupdate/skillBasedQueueValidation';
import { ResourceData, ResourceId, useBaseCrudService } from 'framework/crud';
import { cloneDeep } from 'lodash';
import { FormFieldsData } from 'framework/form';

const SKILL_BASED_QUEUE_API_PATH = '/skillBasedQueues';

export const READ_SKILL_BASED_QUEUES_LIST = 'SKILL_BASED_QUEUE_READ_LIST';
export const READ_SKILL_BASED_QUEUE = 'READ';
export const CREATE_SKILL_BASED_QUEUE = 'SKILL_BASED_QUEUE_CREATE';
export const UPDATE_SKILL_BASED_QUEUE = 'CREATE';
export const DELETE_SKILL_BASED_QUEUE = 'DELETE';
export const DISABLED_PERMISSION = 'DISABLED_PERMISSION';

const useSkillBasedQueueService = () => {
  const singleResourceUrl = `${SKILL_BASED_QUEUE_API_PATH}/:id`;
  const { sendGetRequest, sendPutRequest } = usePeopleManagementApi();
  const {
    search: baseSearch,
    update: baseUpdate,
    ...baseCrudRequests
  } = useBaseCrudService({
    singleResourceUrl,
    listResourceUrl: SKILL_BASED_QUEUE_API_PATH,
    useService: usePeopleManagementApi,
  });

  const getValidationSchema = () => Promise.resolve(skillBasedQueueValidation);

  const search = (request: ResourceData) => {
    const searchParams = cloneDeep(request);
    const searchString = searchParams.filter?.['specification:search']?.eq || '';

    if (searchString && searchParams.filter) {
      delete searchParams.filter?.['specification:search'];
      searchParams.filter['skill.name'] = {
        ct: searchString,
      };
    }

    return baseSearch(searchParams);
  };

  const update = async (skillBasedQueueId: StringOrNumber, data: FormFieldsData) => {
    const result = await sendPutRequest(`${SKILL_BASED_QUEUE_API_PATH}/${skillBasedQueueId}`, data);
    return result.json();
  };

  const getPplPermissions = async (id: ResourceId) => {
    try {
      const response = await sendGetRequest(`/permissions/SkillBasedQueue/${id}`);
      return response.json();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('getPermissions SkillBasedQueue: Failed to fetch global permissions:', error);
      return [];
    }
  };

  return {
    getValidationSchema,
    ...baseCrudRequests,
    search,
    getPplPermissions,
    update,
  };
};

export default useSkillBasedQueueService;
